import React from 'react'
import Layout from '../components/layout/Layout'
import Research from '../components/research/Research'

export default function ResearchPage() {

  return (
    
        <Layout>
            <Research/>
        </Layout>
     
  )
}
